/**
 * @flow
 *
 * Refcounted body scroll lock for modal dialogs.
 *
 * Multiple dialogs may be open at once (e.g. a destroy-confirm vanilla alertDialog opening on top
 * of a React DismissableModal). If each dialog independently snapshotted body styles on open and
 * restored them on close, the second dialog's snapshot would capture the already-locked styles —
 * so closing it would leave the page locked until the outer dialog also closed. We track the
 * number of active locks and only mutate body styles when transitioning between 0 and ≥1 active.
 */

let activeLockCount: number = 0;
let originalBodyOverflow: string = "";
let originalHtmlOverflow: string = "";
let originalBodyPaddingRight: string = "";

export function lockBodyScroll() {
  if (activeLockCount === 0) {
    const { body, documentElement } = document;
    if (!body || !documentElement) {
      return;
    }
    const scrollbarWidth = window.innerWidth - documentElement.clientWidth;
    originalBodyOverflow = body.style.overflow;
    originalHtmlOverflow = documentElement.style.overflow;
    originalBodyPaddingRight = body.style.paddingRight;

    body.style.overflow = "hidden";
    documentElement.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
  activeLockCount += 1;
}

export function unlockBodyScroll() {
  if (activeLockCount === 0) {
    return;
  }
  activeLockCount -= 1;
  if (activeLockCount === 0) {
    const { body, documentElement } = document;
    if (!body || !documentElement) {
      return;
    }
    body.style.overflow = originalBodyOverflow;
    documentElement.style.overflow = originalHtmlOverflow;
    body.style.paddingRight = originalBodyPaddingRight;
  }
}
